import { render } from "./HafalanPage.vue?vue&type=template&id=67acd430&scoped=true"
import script from "./HafalanPage.vue?vue&type=script&lang=js"
export * from "./HafalanPage.vue?vue&type=script&lang=js"

import "./HafalanPage.vue?vue&type=style&index=0&id=67acd430&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67acd430"]])

export default __exports__